export type ReceiverOutput<T> = AsyncGenerator<T>
